import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/AuthProvider';

export enum InfoStep {
  NONE = -1,
  OPEN_CLASS = 0,
  OPEN_UNIT = 1,
  OPEN_MODULE = 2,
  OPEN_CONTENT = 3,
}

const useTutorialInfo = () => {
  const user = useContext(AuthContext);
  const [currentStep, setCurrentStep] = useState<InfoStep>(InfoStep.NONE);

  const getLocalStorageKey = () => {
    if (!user) {
      return 'tutorial';
    }
    return `tutorial-${user?.pk}`;
  };

  const storeCurrentStep = (newCurrentStep: number) => {
    setCurrentStep(newCurrentStep);
    const key = getLocalStorageKey();
    localStorage.setItem(key, newCurrentStep.toString());
  };

  const nextStep = () => {
    if (currentStep === InfoStep.NONE) {
      return;
    }
    const step = getStep(currentStep + 1);
    storeCurrentStep(step);
  };

  const getStep = (stepNumber: number) => {
    let step = InfoStep.NONE;
    if (stepNumber === 0) {
      step = InfoStep.OPEN_CLASS;
    } else if (stepNumber === 1) {
      step = InfoStep.OPEN_UNIT;
    } else if (stepNumber === 2) {
      step = InfoStep.OPEN_MODULE;
    } else if (stepNumber === 3) {
      step = InfoStep.OPEN_CONTENT;
    }
    return step;
  };

  useEffect(() => {
    if (!user?.is_demo) {
      return;
    }
    const key = getLocalStorageKey();
    const storedStep = localStorage.getItem(key);
    let storedStepNumber = -1;
    try {
      if (storedStep) {
        storedStepNumber = parseInt(storedStep);
      } else if (storedStep === null) {
        storedStepNumber = 0;
      }
    } catch (e) {}
    const step = getStep(storedStepNumber);
    storeCurrentStep(step);
  }, [user]);

  return { currentStep, nextStep };
};

export default useTutorialInfo;
